import React, { useState, useEffect, useContext } from 'react';
import AppBar from './components/AppBar';
import fire from "./firebase/firebase"
import firebase from 'firebase';
import { useNavigate, useParams } from "react-router-dom";
import { postImage } from "./services/picnicapi"
import { getTranslation } from './services/translatorapi';
import { Skeleton, VStack, HStack, Stack, Text, Pressable, Box } from 'native-base';
import { getZonaApi } from "./services/picnicapi";
import DetailRow from "./components/DetailRow"
import IosWoman from 'react-ionicons/lib/IosWoman'
import IosSquare from 'react-ionicons/lib/IosSquare'
import IosWater from 'react-ionicons/lib/IosWater'
import IosBasketball from 'react-ionicons/lib/IosBasketball'
import IosRestaurant from 'react-ionicons/lib/IosRestaurant'
import IosNavigate from 'react-ionicons/lib/IosNavigate'
import IosMegaphone from 'react-ionicons/lib/IosMegaphone'
import IosShare from 'react-ionicons/lib/IosShare'
import AlertBox from "./components/AlertBox"
import { LanguageContext } from './context/LanguageProvider';
import imageCompression from 'browser-image-compression';
import {Helmet} from "react-helmet"

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

export default function DetailPage() {
    let { id } = useParams();
    const navigate = useNavigate();
    const [state, setState] = useState(null);
    const [userLocation, setUserLocation] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [showSuccess, setShowSucces] = useState(false);
    const [loading, setLoading] = useState(true);
    const [descriptionText, setDescriptionText] = useState(state?.descripcion);
    const [descriptionTranslated, setDescriptionTranslated] = useState(false);
    const { i18n, language } = useContext(LanguageContext)
    
    useEffect(() => {
        let splitName = id.split("-");
        let realId = splitName[splitName.length -1]
        getZonaApi(realId).then((data)=> { 
            setState(data);
            setDescriptionText(data.descripcion)
            setLoading(false);
        })
        if (state)
        {
            fire.logEvent("abrir_detalle", { name: state.nombre });
        }
        let watcher = navigator.geolocation.watchPosition(function (position) {
            setUserLocation(position);
        })
        return () => {
            navigator.geolocation.clearWatch(watcher)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state?.nombre])

    const googleMapsDirections = () => {
        if (userLocation !== null) {
            return "https://maps.google.com?saddr=" + userLocation?.coords.latitude + "," + userLocation?.coords.longitude + "&daddr=" + state.lat + "," + state.lon;
        } else {
            return null;
        }
    }

    function getImages(lat, lon) {
        if (state.imageUrls.length > 0) {
            return state.imageUrls;
        }
        return ["https://maps.googleapis.com/maps/api/staticmap?size=600x400&center=" + lat + "," + lon + "&zoom=18&maptype=satellite&key=AIzaSyB4VHalApWAWsLWoNT2esCQQCEMcBwrp5U"];
    }

    function changeImage() {
        document.getElementById("button-upload-file").click();
    }

    function translateDescription()
    {
        setDescriptionTranslated(true);
        setLoading(true);
        getTranslation(state.descripcion, language).then(function (result) {
            try
            {
                setDescriptionText(result.data.translations[0]?.translatedText || descriptionText);
            }catch(e){}
            setLoading(false);
        })
    }

    function uploadImage() {
        return new Promise(async (resolve, reject) => {
            setLoading(true);
            const filePicker = document.querySelector('input#button-upload-file');

            if (!filePicker || !filePicker.files
                || filePicker.files.length <= 0) {
                reject('No file selected.');
                return;
            }
            let myFile = filePicker.files[0];
            const options = {
                maxWidthOrHeight: 1280,
                maxSizeMB: 1,
                alwaysKeepResolution:true,
            }
            try {
                myFile = await imageCompression(myFile, options);
            } catch (error) {
                console.log(error);
            }
            try {
                const storagePathAndFilename = `images/${state.nombre.replaceAll(" ", "_").toLowerCase()}/${myFile.name}`
                const ref = firebase.storage().ref(storagePathAndFilename);

                await ref.put(myFile);
                const myDownloadUrl = await ref.getDownloadURL();
                const addImage = { ...state, url_imagen: myDownloadUrl };
                postImage(addImage).then(() => {
                    setState(addImage)
                    setLoading(false);
                    setShowSucces(true);
                    fire.logEvent("nueva_imagen", { name: state.nombre });
                })
                resolve();
            } catch (err) {
                reject(err);
            }
        });
    }
    const onCloseSucces = () => {
        setShowSucces(false);
    }
    
    const onShare = async() =>{

        const title = i18n.t("share_title");
        const url = document.querySelector("link[rel=canonical]")
          ? document.querySelector("link[rel=canonical]").href
          : document.location.href;
        const text = i18n.t("share_text");
        try {
            await navigator
            .share({
              title,
              url,
              text
            })
              alert(i18n.t("share_thanks"));
          } catch (err) {
            navigator.clipboard.writeText(url).then(() => {
              alert(i18n.t("share_copied_to_clipboard"));
            });
        }
      }

    const pushContactErrorPage = () => {
        navigate('/contacterror',
            {
                state: state
            });
    }

    const getDetailRowSkeleton = () =>{
        return (
            <HStack space="2" alignItems="center">
                <Skeleton h="5" w="5" />
                <Skeleton h="3" w="150px"/>
                <Skeleton size="5" rounded="full" />
            </HStack>
        )
    }

    if (!state && !loading)
    {
        return (<>
            <AppBar
                title={i18n.t("title_detalle")}
                backButton={true}
                actions={[{ spinner: loading }]} />
            <div style={{ width: '100%', marginTop: "70px", marginBottom: "30px", textAlign: "center"}}>
                <h3>Area not found</h3>
                <img width="250px" src="https://cdn.pixabay.com/animation/2022/11/13/04/07/04-07-28-574_512.gif" alt="area not found"/>
            </div>
        </>)
    }

    if (!state)
    {
        return (<>
            <AppBar
                title={i18n.t("title_detalle")}
                backButton={true}
                actions={[{ spinner: loading }]} />
            <div style={{ width: '100%', marginTop: "70px", marginBottom: "30px" }}>
                <Stack direction={["column", "column", "column", "row"]} alignItems={["center", "center", "center", "top"]} style={{ margin: "15px" }} space="5">
                    <div width="fit-content">
                        <Skeleton w={["300px", "400px", "500px"]} h={["220px", "270px", "300px"]} borderRadius="10px" />
                    </div>
                    <VStack alignItems="center" space="2">
                    <Skeleton h="5" w={["200px", "300px", "300px"]}/>
                    <Skeleton h="5" w={["180px", "260px", "260px"]}/>
                    <div style={{ marginTop: "15px" }} />
                    <VStack alignItems="left" space="2">
                        {getDetailRowSkeleton()}
                        {getDetailRowSkeleton()}
                        {getDetailRowSkeleton()}
                        {getDetailRowSkeleton()}
                        {getDetailRowSkeleton()}
                    </VStack>
                    </VStack>
                    <div style={{ marginTop: "15px" }} />
                    <div margin="inherit">
                        <Skeleton.Text w={["315px", "400px", "300px"]}/>
                    </div>
                </Stack>
            </div>
        </>)
    }
    return (<>
        <Helmet>
            <title>{state.nombre}</title>
            <meta name="description" content={state.descripcion} />
            <meta name="robots" content="index, follow"/>
        </Helmet>
        <AppBar 
            title={i18n.t("title_detalle")} 
            backButton={true} 
            actions={[{ spinner: loading },
                      { icon: <IosNavigate color="white" />, link: googleMapsDirections() },
                    { icon: <IosMegaphone color="white" />, onClick: () => {pushContactErrorPage()} },
                    { icon: <IosShare color="white" />, onClick: () => {onShare()} }]} />
        <AlertBox
            header={i18n.t("change_detail_image_titulo")}
            body={i18n.t("change_detail_image_enviado")}
            isOpen={showSuccess}
            textButton1={i18n.t("btn_ok")}
            onPressButton1={() => onCloseSucces()} />
        <div style={{ width: '100%', marginTop: "70px", marginBottom: "30px"}}>
            <Stack direction={["column","column","column", "row"]} alignItems={["center","center","center", "top"]} style={{ margin: "15px" }} space="5">
                <div width="fit-content">
                    {!imageLoaded && (<Skeleton w={["300px", "400px", "500px"]} h={["220px", "270px", "300px"]}/>)}
                        <Box w={["300px", "400px", "500px"]}>
                            <Carousel 
                                infiniteLoop
                                autoPlay 
                                showStatus={false} 
                                showThumbs={false} 
                                interval={5000} 
                                animationHandler="slide" 
                                transitionTime={1000}>
                            {getImages(state.lat, state.lon).map((img) =>{
                                return (<div style={{backgroundColor:"white"}}>
                                   <img onLoad={() => { setImageLoaded(true);}} src={img} 
                                    onError={(img)=> {
                                        img.currentTarget.onerror=null;
                                        img.currentTarget.src="https://cdn.pixabay.com/animation/2023/01/24/22/44/22-44-04-445_512.gif"}} 
                                    alt="Foto de la zona" style={{ borderRadius:"10px", display: imageLoaded ? "block" : "none"}} />
                                </div>)
                            })}
                            </Carousel>
                        </Box>
                    <Pressable onPress={() => changeImage()} style={{ display: "flex", alignItems: "center", textAlign: "center", marginTop:"10px" }}>
                        <Text style={{ color: "#556b2f" }} fontSize="md" bold>{i18n.t("change_detail_image_foto")}</Text>
                        <input style={{ display: "none" }} accept="image/*" id="button-upload-file" type="file" onChange={() => uploadImage()} />
                    </Pressable>
                </div>
                <VStack alignItems="center">
                    <h1>{state.nombre}</h1>
                    <h3>{state.ciudad}</h3>
                    <div style={{ marginTop: "15px" }} />
                    <VStack alignItems="left">
                        <DetailRow icon={<IosWoman />} name={i18n.t("detalles_aseos")} state={state.aseos} />
                        <DetailRow icon={<IosWater />} name={i18n.t("detalles_banyo")} state={state.zona_banyo} />
                        <DetailRow icon={<IosBasketball />} name={i18n.t("detalles_zona_infantil")} state={state.zona_infantil} />
                        <DetailRow icon={<IosSquare />} name={i18n.t("detalles_mesas")} state={state.mesas} />
                        <DetailRow icon={<IosRestaurant />} name={i18n.t("detalles_alimentacion")} state={state.bar} />
                    </VStack>
                </VStack>
                <div style={{ marginTop: "15px" }} />
                <div margin="inherit">
                    <VStack space="3">
                        <Text>{descriptionText}</Text>
                        {!descriptionTranslated && descriptionText?.length > 0 && (<Text style={{color: "darkolivegreen", fontWeight:"700", cursor:"pointer"}} textAlign="center" onClick={() => translateDescription()}>{i18n.t("translate_to")}</Text>)}
                    </VStack>
                </div>
            </Stack>
        </div>
        </>
    );
}